module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/061-saba-island-dfa5b76e342221eaf928105dd1653ddb.svg";